export const sortOrders = {
  ASC: 'ascending',
  DES: 'descending',
};
